export default __webpack_public_path__ + "static/media/event-illustration.acd76240.webp";